module.exports = "<div\r\n  *ngIf=\"isLoading\"\r\n  class=\"loader-overlay\"\r\n  role=\"status\"\r\n  aria-live=\"polite\"\r\n  aria-label=\"Loading\">\r\n  <img [src]=\"eduManlogoUrl\" alt=\"Loading\" />\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ixsloader/ixsloader.component.html
// module id = 1207
// module chunks = 320